interface Props {
  triggerSelector: string
  dialogSelector: string
  closeSelector: string
  contentSelector: string
}

function dialogModal(
  el: HTMLElement,
  { triggerSelector, dialogSelector, closeSelector, contentSelector }: Props
) {
  const dialogEl = el.querySelector<HTMLDialogElement>(dialogSelector)
  const triggerEls = el.querySelectorAll<HTMLButtonElement>(triggerSelector)
  const closeEl = el.querySelector<HTMLButtonElement>(closeSelector)
  const contentEl = el.querySelector<HTMLElement>(contentSelector)

  if (!dialogEl || !triggerEls || !closeEl || !contentEl) {
    return
  }
  const openEvent = new CustomEvent("formDialogOpened", { detail: dialogEl.id })

  // Open events
  triggerEls.forEach(triggerEl => {
    triggerEl.addEventListener("click", () => {
      dialogEl.dispatchEvent(openEvent)
      dialogEl.showModal()
      document.body.setAttribute("inert", "true")
      document.body.classList.add("overflow-y-hidden")
    })
  })

  // Close events
  closeEl.addEventListener("click", () => {
    dialogEl.close()
  })

  // Ensure dialogEl covers whole screen
  dialogEl.addEventListener("click", e => {
    if (!(e.target instanceof HTMLElement)) {
      return
    }

    // Ignore instantsearch.js elements
    if (e.target.classList.value.split(" ").some(c => c.startsWith("ais"))) {
      return
    }

    if (
      !contentEl.contains(e.target) &&
      !e.target.closest(triggerSelector) &&
      dialogEl.open
    ) {
      e.preventDefault()
      dialogEl.close()
    }
  })

  // Close modal cleanup
  dialogEl.addEventListener("close", () => {
    document.body.removeAttribute("inert")
    document.body.classList.remove("overflow-y-hidden")
  })
}

export default dialogModal
